import React from 'react';

interface DropdownLinkProps {
  href: string;
  icon: string;
  text: string;
}

const DropdownLink = ({ text, icon, href }: DropdownLinkProps) => (
  <a
    className="dropdown-item"
    href={href}
    role="button"
  >
    <i aria-hidden="true" className={`fa ${icon}`} />
    {text}
  </a>
);

export default DropdownLink;
